import { Component, Input, OnInit } from '@angular/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-footer-upper',
  templateUrl: './footer-upper.component.html',
  styleUrls: ['./footer-upper.component.scss'],
})
export class FooterUpperComponent {
  @Input() sizeClass: String | undefined;

  constructor(private stateManagementService: StateManagementService) {}

// this function is getting navigated to link of Product
  navigateToProduct(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.PRODUCT_LINK_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.PRODUCT_LINK_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.PRODUCT_LINK, '_blank');
    }
  }

  // this function is getting navigated to link of Support Center
  navigateToSupportCenter(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.SUPPORT_CENTER_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.SUPPORT_CENTER_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.SUPPORT_CENTER, '_blank');
    }
  }

  // this function is getting navigated to link of Apps
  navigateToApps(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.APPS_LINK_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.APPS_LINK_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.APPS_LINK, '_blank');
    }
  }
}
